import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AddProductPage.css";
import { IoClose } from "react-icons/io5";

import { db } from "../../firebase";
import { collection, addDoc } from "firebase/firestore";

export default function AddProductPage() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    price: "",
    oldprice: "",
    category: "",
    images: [],
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "images") {
      setFormData({
        ...formData,
        images: Array.from(files),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // 🔥 Upload single image to Cloudinary
  const uploadToCloudinary = async (imageFile) => {
    const data = new FormData();
    data.append("file", imageFile);
    data.append("upload_preset", "Chaitany Flower shop"); // change this
    data.append("cloud_name", "daefe8kaq"); // change this

    const res = await fetch(
      "https://api.cloudinary.com/v1_1/daefe8kaq/image/upload",
      {
        method: "POST",
        body: data,
      },
    );

    const result = await res.json();
    return result.secure_url;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const imageUrls = [];

      for (let i = 0; i < formData.images.length; i++) {
        const url = await uploadToCloudinary(formData.images[i]);
        imageUrls.push(url);
      }

      await addDoc(collection(db, "products"), {
        name: formData.name,
        price: Number(formData.price),
        oldprice: Number(formData.oldprice),
        category: formData.category,
        images: imageUrls,
        createdAt: new Date(),
      });

      alert("Product Added Successfully");
      navigate("/admin/products");
    } catch (error) {
      console.error(error);
      alert("Error adding product");
    }
  };

  return (
    <section className="add-product-page">
      <div className="product-form-page">
        <h2>Add Product</h2>
        <hr />

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            type="number"
            name="price"
            placeholder="Price"
            value={formData.price}
            onChange={handleChange}
            required
          />

          <input
            type="number"
            name="oldprice"
            placeholder="Old Price"
            value={formData.oldprice}
            onChange={handleChange}
          />

          <div className="category-options">
            <span>Category : </span>
            <>
              <input
                type="radio"
                name="category"
                value="garland"
                onChange={handleChange}
              />{" "}
              Garland
            </>
            <>
              <input
                type="radio"
                name="category"
                value="bouquet"
                onChange={handleChange}
              />{" "}
              Bouquet
            </>
            <>
              <input
                type="radio"
                name="category"
                value="weddingGarland"
                onChange={handleChange}
              />{" "}
              Wedding Garland
            </>
            <>
              {" "}
              <input
                type="radio"
                name="category"
                value="carGarland"
                onChange={handleChange}
              />{" "}
              Car Garland
            </>
            <>
              <input
                type="radio"
                name="category"
                value="carDecoration"
                onChange={handleChange}
              />{" "}
              Car Decoration
            </>
            <>
              <input
                type="radio"
                name="category"
                value="flowerAccessories"
                onChange={handleChange}
              />{" "}
              Flower Accessories
            </>
          </div>

          <input
            type="file"
            name="images"
            accept="image/*"
            multiple
            onChange={handleChange}
            required
          />

          <button type="submit">Add Product</button>
        </form>
      </div>

      <div className="cancel-button">
        <IoClose
          className="close"
          onClick={() => navigate("/admin/products")}
        />
      </div>
    </section>
  );
}
